import { Square, MovementSquare } from "../model/square.js";

export let path = [];

let coordinates = [[175, 848], [247, 826], [305, 817], [353, 820], [397, 822], [467, 819], [502, 830], [560, 848], [607, 852], [667, 873],
[670, 813], [641, 763], [608, 716], [567, 688], [511, 663], [458, 667], [413, 672], [357, 668], [310, 680], [258, 684], 
[204, 687], [149, 688], [101, 691], [86, 625], [110, 584], [170, 556], [223, 533], [273, 545], [326, 545], [371, 545], 
[424, 549], [488, 561], [534, 558], [586, 542], [637, 525], [638, 458], [605, 413], [561, 370], [556, 322], [623, 297], 
[660, 250], [656, 207], [602, 178], [562, 173], [515, 198],[467, 226], [434, 257], [410, 312], [406, 353], [428, 415], [373, 418], [331, 412], 
[272, 405], [228, 384], [170, 351], [140, 330], [122, 280],[99, 233], [124, 175], [180, 154], [225, 153], [278, 153], [329, 156], [381, 133], 
[439, 89]]

for (let i = 0; i <= 64; i++) {
  if ([12, 24, 36, 48, 60].includes(i)) {
    path.push(new Square(i, new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]), "magic-x3"));
  }
  else if ([4, 22, 44, 56].includes(i)) {
    path.push(new MovementSquare(i, new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]), "movement", i + 2));
  } else if ([14, 30, 42, 52, 62].includes(i)) {
    path.push(new MovementSquare(i, new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]), "movement", i - 2));
  } else if (i === 33) {
    path.push(new MovementSquare(i, new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]), "movement", i + 1));
  } else {
    path.push(new Square(i, new Phaser.Math.Vector2(coordinates[i][0], coordinates[i][1]), "basic"));
  }
}
